module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "pp-navbar__search"
  }, [_vm._m(0), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.query),
      expression: "query"
    }],
    staticClass: "pp-navbar__search__input",
    attrs: {
      "type": "text",
      "placeholder": _vm.view == 'mobile' ? 'Search for albums or tracks' : 'Search for albums or tracks by title, composer, ensemble, artist, or code'
    },
    domProps: {
      "value": (_vm.query)
    },
    on: {
      "keydown": _vm.onKeyDown,
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.query = $event.target.value
      }
    }
  })])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "pp-varbar__search__icon"
  }, [_c('i', {
    staticClass: "fa fa-fw fa-search"
  })])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-6290160c","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/NavBarSearch.vue
// module id = 131
// module chunks = 0 1